import React from "react";
import {Field, useFormState} from "react-final-form";
import {useSelector} from "react-redux";
import usePrice from "../../hooks/usePrice";
import useCalculator from "../../hooks/useCalculator";
import {useIsShowMap} from "../../hooks/useIsShowMap";
import useSyncedField from "../../hooks/useSyncedField";

function AdditionalServices() {
    const {values} = useFormState();
    const {features} = useSelector(state => state.orderOptions.data);
    const {priceFormat} = usePrice();
    const {calculateFeaturePrice} = useCalculator();
    const isShowMap = useIsShowMap(values);
    useSyncedField('plagiarismReport', 'int');
    useSyncedField('abstractPage','int');
    useSyncedField('editorCheck', 'int');

    return (isShowMap.plagiarismReport || isShowMap.abstractPage || isShowMap.editorCheck) ? (
        <div className="form-group">
            <div className="form-label">Additional features</div>
            <div className="accordion-wrap">
                {isShowMap.plagiarismReport && (
                    <label className={`accordion-item checkbox-default ${values.plagiarismReport ? 'checked' : ''}`}>
                        <div className="accordion-title-wrap">
                            <div className="accordion-title">
                                <div className="accordion-title__icon"><img src="/_core/assets/themes/v5/assets/img/form3/srv-icon-new-1.svg" alt=""/></div>
                                <div className="accordion-title__right">
                                    <div className="accordion-title__group">
                                        <span>{features.plagiarismReport.label}</span>
                                    </div>
                                    <div className="srv-price">+ {priceFormat(calculateFeaturePrice(features.plagiarismReport))}</div>
                                </div>
                            </div>
                            <div className="accordion-title-right">
                                <Field
                                    name="plagiarismReport"
                                    type="checkbox"
                                    component="input"
                                    className="checkbox-item"
                                    parse={v => v ? 1 : 0}
                                />
                                <span className="checkbox-default__checkmark">
                                    <div className="checkbox-default__checkmark-icon">
                                        <img src="/_core/assets/themes/v5/assets/img/form3/default-check-icon.svg" alt=""/>
                                    </div>
                                </span>
                            </div>
                        </div>
                        <div className="accordion-content">
                            <p>
                                Receive an official document with a detailed analysis of your work from a premium plagiarism detective system.
                            </p>
                            <div className="srv-price-mobile">+ {priceFormat(calculateFeaturePrice(features.plagiarismReport))}</div>
                        </div>
                    </label>
                )}

                {isShowMap.abstractPage && (
                    <label className={`accordion-item checkbox-default recommended ${values.abstractPage ? 'checked' : ''}`}>
                        <div className="accordion-title-wrap">
                            <div className="accordion-title">
                                <div className="accordion-title__icon"><img src="/_core/assets/themes/v5/assets/img/form3/srv-icon-new-2.svg" alt=""/></div>
                                <div className="accordion-title__right">
                                    <div className="accordion-title__group">
                                        <span>{features.abstractPage.label}</span>
                                    </div>
                                    <div className="srv-price">+ {priceFormat(calculateFeaturePrice(features.abstractPage))}</div>
                                </div>
                            </div>
                            <div className="accordion-title-right">
                                <Field
                                    name="abstractPage"
                                    type="checkbox"
                                    component="input"
                                    className="checkbox-item"
                                    parse={v => v ? 1 : 0}
                                />
                                <span className="checkbox-default__checkmark">
                                    <div className="checkbox-default__checkmark-icon">
                                        <img src="/_core/assets/themes/v5/assets/img/form3/default-check-icon.svg" alt=""/>
                                    </div>
                                </span>
                            </div>
                        </div>
                        <div className="accordion-content">
                            <p>
                                A concise summary (also called an executive summary) of the main points of your paper. It is highly recommended for the APA format.
                            </p>
                            <div className="srv-price-mobile">+ {priceFormat(calculateFeaturePrice(features.abstractPage))}</div>
                        </div>
                    </label>
                )}

                {isShowMap.editorCheck && (
                    <label className={`accordion-item checkbox-default ${values.editorCheck ? 'checked' : ''}`}>
                        <div className="accordion-title-wrap">
                            <div className="accordion-title">
                                <div className="accordion-title__icon"><img src="/_core/assets/themes/v5/assets/img/form3/srv-icon-new-3.svg" alt=""/></div>
                                <div className="accordion-title__right">
                                    <div className="accordion-title__group">
                                        <span>{features.editorCheck.label}</span>
                                    </div>
                                    <div className="srv-price">+ {priceFormat(calculateFeaturePrice(features.editorCheck))}</div>
                                </div>
                            </div>
                            <div className="accordion-title-right">
                                <Field
                                    name="editorCheck"
                                    type="checkbox"
                                    component="input"
                                    className="checkbox-item"
                                    parse={v => v ? 1 : 0}
                                />
                                <span className="checkbox-default__checkmark">
                                    <div className="checkbox-default__checkmark-icon">
                                        <img src="/_core/assets/themes/v5/assets/img/form3/default-check-icon.svg" alt=""/>
                                    </div>
                                </span>
                            </div>
                        </div>
                        <div className="accordion-content">
                            <p>
                                A professional editor will check your pages for grammar, lexis, context, and format to make it unexceptionable.
                            </p>
                            <div className="srv-price-mobile">+ {priceFormat(calculateFeaturePrice(features.editorCheck))}</div>
                        </div>
                    </label>
                )}
            </div>
        </div>
    ) : '';
}

export default AdditionalServices;
